import { Contributors } from '@/app/(webapp)/_types/contributors';

export const partners: Contributors[] = [
    { id: 'aws', name: 'Amazon Web Services', src: '/images/partners/aws.png' },
    { id: 'imdb', name: 'IMDB', src: '/images/partners/imdb.png' },
    { id: 'bnp', name: 'BNP Paribas', src: '/images/partners/bnp.png' },
];
